import { render, staticRenderFns } from "./AssignedAlertsList.vue?vue&type=template&id=21f30f92&scoped=true&"
import script from "./AssignedAlertsList.vue?vue&type=script&lang=ts&"
export * from "./AssignedAlertsList.vue?vue&type=script&lang=ts&"
import style0 from "./AssignedAlertsList.vue?vue&type=style&index=0&id=21f30f92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f30f92",
  null
  
)

export default component.exports